import { administrationRequests } from "api/administrationApi";
import { ROOMS } from "utils/constants";
import { createExporter } from "utils/createExporter";

const filename = ROOMS.replace(/[-/]/g, "_");

export const InternalRoomsExporter = createExporter(
  `${filename}.xlsx`,
  [
    { key: "nameBg", label: "име на български език" },
    { key: "nameEn", label: "име на английски език" },
    { key: "building", label: "сграда" },
    { key: "floor", label: "етаж" },
    { key: "number", label: "номер" },
    { key: "type", label: "тип" },
    { key: "capacityClasses", label: "капацитет за лекции/упражнения" },
    { key: "capacityExam", label: "капацитет за изпит" },
    { key: "classTypes", label: "тип занятия" },
  ],
  record => ({
    ...record,
    type: record.type?.name,
    classTypes: Array.isArray(record.classTypes) ? record.classTypes.map(ct => ct?.name).join(", ") : "",
    building: record.building?.name,
  }),
  [
    {
      source: "buildingId",
      target: administrationRequests.getBuildingsSelect(),
      name: "building",
    },
    {
      source: "typeId",
      target: administrationRequests.getRoomTypesSelect(),
      name: "type",
    },
    {
      source: "classTypeIds",
      target: administrationRequests.getRoomClassTypesSelect(),
      name: "classTypes",
    },
  ],
);
